export default "__VITE_ASSET__$ug12sJu__"